module.exports = __webpack_public_path__ + "img/beach-getaway.704bd387.jpg";